import * as types from './mutations_types.js'

export const state = {
  userId: '',
  userName: '',
  userEmail: '',
  token: '',
  apiuri: 'https://admin.weddingsung.com/api/',
  testuri: 'http://songsadmin.localhost/api/',
  authenticated: false,
  hot: [],
  slide: [],
  songCategory: [],
  songTagLang: [],
  songTagTempo: [],
  songShare: [],
  partnerCategory: [],
  songLatest: [],
  songSpecial: [],
  activity: [],
  article: []
}

export const mutations = {
  [types.SET_TOKEN] (state, token) {
    state.token = token
  },
  [types.LOGOUT] () {
    localStorage.removeItem('userId')
    localStorage.removeItem('userName')
    localStorage.removeItem('userEmail')
    localStorage.removeItem('token')
    state.userId = ''
    state.userName = ''
    state.userEmail = ''
    state.token = ''
    state.authenticated = false
  },
  [types.UPDATEUSER] (state, creds) {
    let data = creds.data
    if (localStorage) {
      state.userName = data.userName
      state.userEmail = data.userEmail
      localStorage.setItem('userName', data.userName)
      localStorage.setItem('userEmail', data.userEmail)
    }
  },
  [types.LOGIN] (state, creds) {
    let data = creds.data
    state.userId = data.userId
    state.userName = data.userName
    state.token = data.token
    state.userEmail = data.userEmail
    localStorage.setItem('userId', data.userId)
    localStorage.setItem('userName', data.userName)
    localStorage.setItem('token', data.token)
    localStorage.setItem('userEmail', data.userEmail)
    state.authenticated = true
  },
  [types.SET_HOT] (state, data) {
    state.hot = data
    localStorage.setItem('hot', JSON.stringify(data))
  },
  [types.SET_SLIDE] (state, data) {
    state.slide = data
    localStorage.setItem('slide', data)
  },
  [types.SET_SONG_TAG_LANG] (state, data) {
    state.songTagLang = data
    localStorage.setItem('songTagLang', JSON.stringify(data))
  },
  [types.SET_SONG_TAG_TEMPO] (state, data) {
    state.songTagTempo = data
    localStorage.setItem('songTagTempo', JSON.stringify(data))
  },
  [types.SET_SONG_CATEGORY] (state, data) {
    state.songCategory = data
    localStorage.setItem('songCategory', JSON.stringify(data))
  },
  [types.SET_SONG_SHARE] (state, data) {
    state.songShare = data
    localStorage.setItem('songShare', JSON.stringify(data))
  },
  [types.SET_SONG_LATEST] (state, data) {
    state.songLatest = data
    localStorage.setItem('songLatest', JSON.stringify(data))
  },
  [types.SET_SONG_SPECIAL] (state, data) {
    state.songSpecial = data
    localStorage.setItem('songSpecial', JSON.stringify(data))
  },
  [types.SET_PARTNER_CATEGORY] (state, data) {
    state.partnerCategory = data
    localStorage.setItem('partnerCategory', JSON.stringify(data))
  },
  [types.SET_ACTIVITY] (state, data) {
    state.activity = data
    localStorage.setItem('activity', JSON.stringify(data))
  },
  [types.SET_HOT] (state, data) {
    state.hot = data
    localStorage.setItem('hot', JSON.stringify(data))
  },
  [types.SET_ARTICLE] (state, data) {
    state.article = data
    localStorage.setItem('article', JSON.stringify(data))
  }
}



// WEBPACK FOOTER //
// ./src/store/home/mutations.js